<template>
<div>
    <v-slide-y-reverse-transition class="py-0" group tag="div">
    <v-snackbar
      v-for="(snackbar, index) in snackbars.filter(s => s.show)" 
      :key="snackbar.text + Math.random()"
      v-model="snackbar.show"
      :left="snackbar.x === 'left'"
      :right="snackbar.x === 'right'"
      :bottom="snackbar.y === 'bottom'"
      :top="snackbar.y === 'top'"
      :multi-line="snackbar.mode === 'multi-line'"
      :vertical="snackbar.mode === 'vertical'"
      :color="snackbar.color || 'success'"
      :style="`${snackbar.y}: ${(index * 60) + 8}px`"
      :timeout="snackbar.timeout || 5000"
    >
       <div style="white-space:pre-line;">{{ snackbar.text }}</div>
      <v-spacer></v-spacer>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">{{$t("common.btn.close")}}</v-btn>
      </template>
    </v-snackbar>
  </v-slide-y-reverse-transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("app");
export default {
  methods: {
    // enter(el) {
    //   el.style.transform = `translateX(100 px)`
    // }
  },
  computed: {
    ...mapState(["snackbars"]),
  },
  data() {
    return {
      notifies: this.$store.state.app.snackbars
    }
  },  
};
</script>
